import { Component } from '@theme/component';

export class SubscriptionPlan extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Parse data about subscriptions from the JSON script tag
    const scriptTag = this.querySelector('script[type="application/json"]');
    if (!scriptTag) {
      console.warn('SubscriptionPlan: Missing <script type="application/json"> with plan data.');
      return;
    }
    
    try {
      this.subscriptionData = JSON.parse(scriptTag.textContent);
      

    } catch(e) {
      console.error('SubscriptionPlan: Error parsing subscription data', e);
      this.subscriptionData = { selling_plan_groups: [], variants_allocations: [] };
    }

    // Find the product container
    const productContainer = this.closest('[data-component="product"]');
    if (!productContainer) {
      console.warn('SubscriptionPlan: Missing parent container with data-component="product".');
      return;
    }

    // Find the product form within the container
    this.productForm = productContainer.querySelector('form[action*="/cart/add"]');
    if (this.productForm) {
      let sellingPlanInput = this.productForm.querySelector('input[name="selling_plan"]');
      if (!sellingPlanInput) {
        sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        this.productForm.appendChild(sellingPlanInput);
      }
      this.sellingPlanInput = sellingPlanInput;
    } else {
      console.warn('SubscriptionPlan: Could not find product form inside [data-component="product"].');
    }

    // Bind event handler for cleanup
    this.handleChange = this.handleChange.bind(this);
    
    // Set up event delegation
    this.optionsContainer = this.querySelector('.subscription-plan__options');
    if (this.optionsContainer) {
      this.optionsContainer.addEventListener('change', this.handleChange);
      
      // Initialize based on the pre-checked input from Liquid
      const checkedInput = this.optionsContainer.querySelector('input[type="radio"]:checked');
      if (checkedInput) {
        this.updateSellingPlan(checkedInput.value);
        this.updateActiveCard(checkedInput);
      } else {
        // Fallback to first input if none are checked
        const firstInput = this.optionsContainer.querySelector('input[type="radio"]');
        if (firstInput) {
          firstInput.checked = true;
          this.updateSellingPlan(firstInput.value);
          this.updateActiveCard(firstInput);
        } else {
          console.warn('SubscriptionPlan: No radio inputs found for selling plans.');
        }
      }
    } else {
      console.warn('SubscriptionPlan: Missing .subscription-plan__options container.');
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.optionsContainer) {
      this.optionsContainer.removeEventListener('change', this.handleChange);
    }
  }

  handleChange(e) {
    if (e.target.matches('input[type="radio"]')) {
      if (e.target.checked) {
        this.updateSellingPlan(e.target.value);
        this.updateActiveCard(e.target);
      }
    }
  }

  updateActiveCard(activeInput) {
    const cards = this.optionsContainer.querySelectorAll('.subscription-plan__card');
    cards.forEach(card => card.classList.remove('subscription-plan__card--active'));

    const activeCard = activeInput.closest('.subscription-plan__card');
    if (activeCard) {
      activeCard.classList.add('subscription-plan__card--active');
    }
  }

  updateSellingPlan(id) {
    if (this.sellingPlanInput) {
      this.sellingPlanInput.value = id;
    }
  }
}

if (!customElements.get('subscription-plan')) {
  customElements.define('subscription-plan', SubscriptionPlan);
}
